import { DecimalPipe, formatCurrency, formatDate, formatNumber, getLocaleCurrencySymbol } from "@angular/common";
import { UserContextService } from "../services/user-context.service";
import { QueryFilter } from "./queryFilter";

export const displayValue = (column, value, localeId) => {
    if (column.type === "select") {
      /** Traduction des combos stockées sur 1 char */
      if (column.firstChar && column.enum) {
        return column.enum.find((elem) => elem.charAt(0) === value);
      }
      /** Traduction des combos type key/value */
      if (column.enum) {
        const i = column.enum.findIndex((elem) => elem.key === value);
        if (i > -1) {
          return column.enum[i].value;
        }
      }
      return value;
    }
  
    if (value === null) {
      return value;
    }
    if (column.displayFormat && column.dataType === "DateTime?") {
      return formatDate(value, column.displayFormat, localeId, undefined);
    } else if (column.dataType === "Currency") {
      return formatCurrency(
        value,
        localeId,
        getLocaleCurrencySymbol(localeId),
        "EUR",
        undefined
      );
    } else if (column.dataType === "decimal?") {
      if (column.displayFormat) {
        return new DecimalPipe(localeId).transform(
          value,
          column.displayFormat,
          localeId
        );
      }
      return formatNumber(value, localeId, "1.0-2");
    } else {
      return value;
    }
  };
  /**
 * Résoud les interpolations {{}} dans une chaine de caractères à partir d'une instance
 * @param path  chaine de caractères
 * @param instance
 * @returns
 */
export const interpolate = (
    path: any,
    instance: any,
    usercontext?: UserContextService
  ) => {
    if (
      path?.length >= 2 &&
      path.indexOf("{{") !== -1 &&
      path.indexOf("}}") !== -1
    ) {
      const interpolations = path
        .match(/{{\s*[\w\.]+\s*}}/g)
        .map((str) => str.match(/[\w\.]+/)[0]);
      interpolations.forEach((element) => {
        if (element === "userConnected") {
          path = path.replace("{{" + element + "}}", usercontext.userConnected);
        } else if (element === "profileConnected") {
          path = path.replace("{{" + element + "}}", usercontext.profil);
        } else if (element === "siteConnexion") {
          path = path.replace("{{" + element + "}}", usercontext.siteConnexion);
        } else if (instance[element] !== undefined) {
          path = path.replace("{{" + element + "}}", instance[element]);
        }
      });
    }
    return path;
  };
  /**
 * Retourne la valeur par défaut à mettre dans le filtre. Cf Documentation.
 * @param filter
 * @param userContext
 * @param whichValue rien ou "2" pour Value ou Value2
 * @returns
 */
export const getFilterValue = (
    filter: any,
    userContext: UserContextService,
    whichValue = ""
  ) => {
    /** Si le filtre de valeur par défaut est un array c'est pour caser différentes valeurs par défaut en fonction du profil ou de l'utilisateur */
    if (Array.isArray(filter)) {
      if (filter.some((f) => f.profileConnected === userContext.profil)) {
        return interpolate(
          filter.find((f) => f.profileConnected === userContext.profil)[
            `Value${whichValue}`
          ],
          {},
          userContext
        );
      } else if (
        filter.some((f) => f.userConnected === userContext.userConnected)
      ) {
        return interpolate(
          filter.find((f) => f.userConnected === userContext.userConnected)[
            `Value${whichValue}`
          ],
          {},
          userContext
        );
      } else if (filter.some((f) => !f.userConnected && !f.profileConnected)) {
        return interpolate(
          filter.find((f) => !f.userConnected && !f.profileConnected)[
            `Value${whichValue}`
          ],
          {},
          userContext
        );
      } else return null;
    } else if (filter !== undefined) {
      if (filter.profileConnected === userContext.profil) {
        return interpolate(filter[`Value${whichValue}`], {}, userContext);
      }
      if (filter.userConnected === userContext.userConnected) {
        return interpolate(filter[`Value${whichValue}`], {}, userContext);
      }
      if (!filter.userConnected && !filter.profileConnected) {
        return interpolate(filter[`Value${whichValue}`], {}, userContext);
      }
    }
  };
  /** Si le F12 est dans la form de recherche, on ne filtre que si TOUS ses filtres sont renseignés */
export const getQueryFilters = (queryFilters: Array<QueryFilter>, parentType: string) => {
 
    const qf =
      parentType === "search" &&
      queryFilters.some(
        (f) => f.fieldName && f.QueryOperator === "Equal" && !f.Value
      )
        ? []
        : [...queryFilters];
    return qf;
  };